import SwishIcon from '@/assets/swish-dark.svg';

export function SwishLogo() {
  return <img width={20} height={20} src={SwishIcon} />;
}
